var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("图表介绍")]),
      _vm._v(" "),
      _c("p", [_vm._v("Area Chart, 面积图。")]),
      _vm._v(" "),
      _c("h3", [_vm._v("attrs")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("attrs 包含若干布局属性，将这些属性放入 Object 对象传入组件")
      ]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("属性名")]),
            _vm._v(" "),
            _c("th", [_vm._v("类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("默认值")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("clientRect")]),
            _vm._v(" "),
            _c("td", [_vm._v("Object")]),
            _vm._v(" "),
            _c("td", [_vm._v("{top,right,bottom,left,width,height}")]),
            _vm._v(" "),
            _c("td", [_vm._v("设置了 width,heigh,优先与 bottom,right")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("smooth")]),
            _vm._v(" "),
            _c("td", [_vm._v("Boolean")]),
            _vm._v(" "),
            _c("td", [_vm._v("false")]),
            _vm._v(" "),
            _c("td", [_vm._v("曲线是否平滑")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("axisGap")]),
            _vm._v(" "),
            _c("td", [_vm._v("Boolean")]),
            _vm._v(" "),
            _c("td", [_vm._v("false")]),
            _vm._v(" "),
            _c("td", [_vm._v("开始绘图区域与坐标轴是否有间隙")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("splitNumber")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_vm._v("0")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "坐标轴的分割段数，用来计算面积图的最大高度，在设置坐标轴的 splitNumber 属性时同步加上"
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("strack")]),
            _vm._v(" "),
            _c("td", [_vm._v("Boolean")]),
            _vm._v(" "),
            _c("td", [_vm._v("true")]),
            _vm._v(" "),
            _c("td", [_vm._v("是否堆叠")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("style 属性")]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c(
          "code",
          { pre: true, attrs: { "v-pre": "", class: "language-javascript" } },
          [
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" area = "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("new")
            ]),
            _vm._v(" Area({ "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("smooth")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-literal" } }, [
              _vm._v("true")
            ]),
            _vm._v(" })\narea.style("),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'area'")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-function" } }, [
              _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
                _vm._v("function")
              ]),
              _vm._v("("),
              _c("span", { pre: true, attrs: { class: "hljs-params" } }, [
                _vm._v("attrs, data, i")
              ]),
              _vm._v(") ")
            ]),
            _vm._v("{\n  "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("if")
            ]),
            _vm._v(" (i === "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("0")
            ]),
            _vm._v(") {\n    "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("return")
            ]),
            _vm._v(" { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("fillColor")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'transparent'")
            ]),
            _vm._v(" }\n  }\n})\n")
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("组件中可以自定义 css 属性的元素如下表：")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("基础类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("guideline")]),
            _vm._v(" "),
            _c("td", [_vm._v("线")]),
            _vm._v(" "),
            _c("td", [_vm._v("指导线样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("line")]),
            _vm._v(" "),
            _c("td", [_vm._v("线")]),
            _vm._v(" "),
            _c("td", [_vm._v("线条样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("area")]),
            _vm._v(" "),
            _c("td", [_vm._v("面")]),
            _vm._v(" "),
            _c("td", [_vm._v("面积样式设置 （Polygon）")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("point")]),
            _vm._v(" "),
            _c("td", [_vm._v("面")]),
            _vm._v(" "),
            _c("td", [_vm._v("线条上标记点样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("point:hover")]),
            _vm._v(" "),
            _c("td", [_vm._v("面")]),
            _vm._v(" "),
            _c("td", [_vm._v("hover 时线条上标记点样式")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }